
















import { Vue, Component } from 'vue-property-decorator';
import LatencyComponent from './latency.component.vue';
import MenuBusinessUnit from './menu-business-unit.component.vue';
import menuItemsData from './menu-items.json';

interface MenuItem {
  label: string;
  routeNames: string[];
  children?: MenuItem[];
}

const ContractImage = require('@/assets/images/icone-folhas.svg');
const BillingImage = require('@/assets/images/icone-faturamento.svg');
const Logo = require('@/assets/images/logo.svg');

@Component({ components: { LatencyComponent, MenuBusinessUnit } })
export default class MenuHeader extends Vue {
  readonly menuItems: MenuItem[] = menuItemsData;

  get activeMenuItem(): MenuItem | undefined {
    const routeName = this.$route.name;
    if (!routeName) return undefined;
    return this.menuItems.find((item) => item.routeNames.some((name) => routeName.includes(name)));
  }

  get activeChildItem(): MenuItem | undefined {
    const routeName = this.$route.name;
    if (!routeName || !this.activeMenuItem?.children) return undefined;
    return this.activeMenuItem.children
      .find((child) => child.routeNames.some((name) => routeName.includes(name)));
  }

  get title() {
    const parentLabel = this.activeMenuItem?.label || 'Visão Geral';
    const childLabel = this.activeChildItem?.label;
    return childLabel ? `${parentLabel} > ${childLabel}` : parentLabel;
  }

  get image() {
    switch (this.activeMenuItem?.label) {
      case 'Faturamentos': return BillingImage;
      case 'Contratos': return ContractImage;
      default: return Logo;
    }
  }

  get isProductionMode() {
    return process.env.NODE_ENV === 'production';
  }

  get logoStyle() {
    return {
      webkitMaskImage: `url(${this.image})`,
      maskImage: `url(${this.image})`,
    };
  }
}
